import { Box, Typography, Divider, Grid } from "@mui/joy";
import { Layers, Palette, Trash2, Hammer, Square } from "lucide-react";
import { FormInput, FormSelect } from "../../../shared";
import { ShingleAndRoofingProps } from "../../../interfaces";
import { RoofPitchField } from "./RoofPitchField";

export function ShingleAndRoofing(props: ShingleAndRoofingProps) {
    const { loading = false } = props;

    return (
        <Box
        >
            <Box mb={2}>
                <Typography level="title-md">Shingle & Roofing</Typography>
                <Typography level="body-sm" color="neutral">
                    Enter the materials and specifications for the main roof
                    covering.
                </Typography>
            </Box>

            <Box
                sx={{
                    p: 2,
                    borderRadius: "4px",
                    border: "1px solid",
                    borderColor: "rgba(128, 128, 128, 0.2)",
                    bgcolor: "rgba(128, 128, 128, 0.05)",
                    backdropFilter: "blur(12px)",
                }}
            >
                <Grid container spacing={2.5}>
                    <Grid xs={12} sm={6} md={4} lg={3}>
                        <FormSelect
                            name="ShingleType"
                            label="Shingle Type"
                            placeholder="Select type"
                            helperText="Specify the material type."
                            disabled={loading}
                            startDecorator={<Layers size={16} />}
                            options={[
                                "3-Tab",
                                "Laminate Shingle",
                                "Premium Laminate",
                                "Premium Laminate - Impact Res.",
                                "Shake Look",
                            ]}
                        />
                    </Grid>

                    <Grid xs={12} sm={6} md={4} lg={3}>
                        <FormInput
                            name="RoofColor"
                            label="Roof Color"
                            placeholder="e.g. Charcoal Black, GAF"
                            helperText="Specify color and manufacturer."
                            disabled={loading}
                            startDecorator={<Palette size={16} />}
                        />
                    </Grid>

                    <Grid xs={12} sm={6} md={4} lg={3}>
                        <FormSelect
                            name="TearOff"
                            label="Tear-Off"
                            placeholder="Select layers"
                            helperText="Number of layers to remove."
                            disabled={loading}
                            startDecorator={<Trash2 size={16} />}
                            options={["0", "1", "2", "3", "4"]}
                        />
                    </Grid>

                    <Grid xs={12} sm={6} md={4} lg={3}>
                        <FormInput
                            name="LowSlopeSQ"
                            type="number"
                            label="Low Slope (SQ)"
                            placeholder="0"
                            helperText="Quantity in squares."
                            disabled={loading}
                            startDecorator={<Square size={16} />}
                            endDecorator={
                                <Typography
                                    level="body-xs"
                                    sx={{
                                        color: "text.tertiary",
                                        fontWeight: "bold",
                                    }}
                                >
                                    SQ
                                </Typography>
                            }
                        />
                    </Grid>

                    <Grid xs={12}>
                        <Box sx={{ my: 0.5 }}>
                            <Divider />
                        </Box>
                    </Grid>

                    <Grid xs={12} sm={6} md={4} lg={3}>
                        <FormSelect
                            name="Starter"
                            label="Starter Type"
                            placeholder="Select starter"
                            helperText="First course of shingles."
                            disabled={loading}
                            startDecorator={<Hammer size={16} />}
                            options={["Pro-Start", "3-Tab Starter", "F96"]}
                        />
                    </Grid>

                    <Grid xs={12} sm={6} md={4} lg={3}>
                        <FormSelect
                            name="RidgeCapProfile"
                            label="Ridge Cap Profile"
                            placeholder="Select profile"
                            helperText="Style of ridge cap."
                            disabled={loading}
                            startDecorator={<Layers size={16} />}
                            options={[
                                "Standard",
                                "Impact Resistant",
                                "High Profile",
                            ]}
                        />
                    </Grid>

                    <Grid xs={12} sm={6} md={4} lg={3}>
                        <FormSelect
                            name="Stories"
                            label="Stories"
                            placeholder="Select stories"
                            helperText="Number of building stories."
                            disabled={loading}
                            startDecorator={<Layers size={16} />}
                            options={["1", "2+"]}
                        />
                    </Grid>

                    <Grid xs={12} sm={6} md={4} lg={3}>
                        <FormInput
                            name="HighRoofSQ"
                            type="number"
                            label="High Roof (SQ)"
                            placeholder="0"
                            helperText="Quantity in squares."
                            disabled={loading}
                            startDecorator={<Square size={16} />}
                            endDecorator={
                                <Typography
                                    level="body-xs"
                                    sx={{
                                        color: "text.tertiary",
                                        fontWeight: "bold",
                                    }}
                                >
                                    SQ
                                </Typography>
                            }
                        />
                    </Grid>

                    <Grid xs={12}>
                        <Box sx={{ my: 0.5 }}>
                            <Divider />
                        </Box>
                    </Grid>

                    <Grid xs={12}>
                        <RoofPitchField disabled={loading} />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
